/**
 * Admin Facilitator Service
 * API calls for super admin to manage buddy facilitators
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const adminFacilitatorAPI = axios.create({
  baseURL: `${API_URL}/admin/facilitators`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
adminFacilitatorAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class AdminFacilitatorService {
  /**
   * Get all facilitators
   */
  async getAllFacilitators() {
    const response = await adminFacilitatorAPI.get('/facilitators');
    return response.data;
  }

  /**
   * Get facilitator by ID
   */
  async getFacilitator(facilitatorId) {
    const response = await adminFacilitatorAPI.get(`/facilitators/${facilitatorId}`);
    return response.data;
  }

  /**
   * Create a new facilitator
   */
  async createFacilitator(data) {
    const response = await adminFacilitatorAPI.post('/facilitators', data);
    return response.data;
  }

  /**
   * Update facilitator
   */
  async updateFacilitator(facilitatorId, data) {
    const response = await adminFacilitatorAPI.put(`/facilitators/${facilitatorId}`, data);
    return response.data;
  }

  /**
   * Delete facilitator
   */
  async deleteFacilitator(facilitatorId) {
    const response = await adminFacilitatorAPI.delete(`/facilitators/${facilitatorId}`);
    return response.data;
  }

  /**
   * Search users
   */
  async searchUsers(query) {
    const response = await adminFacilitatorAPI.get('/users/search', {
      params: { q: query }
    });
    return response.data;
  }

  /**
   * Get system statistics
   */
  async getStats() {
    const response = await adminFacilitatorAPI.get('/stats');
    return response.data;
  }
}

export default new AdminFacilitatorService();
